import { getVmPreference } from "~/lib/auth/vm-preference";
import { subscribeAppAuthTransportSnapshot } from "~/lib/auth/app-auth-runtime";
import {
  createBrowserPlatformApiTrpcAdapter,
  type PlatformApiTrpcClient,
} from "./platform-api-adapter";

let singleton: PlatformApiTrpcClient | null = null;
let unbatchedSingleton: PlatformApiTrpcClient | null = null;
let preloadSingleton: PlatformApiTrpcClient | null = null;
let subscriptionSingleton: PlatformApiTrpcClient | null = null;
let authRuntimeSubscriptionInitialized = false;

function ensureAuthRuntimeSubscription(): void {
  if (authRuntimeSubscriptionInitialized) {
    return;
  }

  authRuntimeSubscriptionInitialized = true;
  subscribeAppAuthTransportSnapshot(() => {
    resetBrowserPlatformApiClient();
  });
}

export function getBrowserPlatformApiClient(): PlatformApiTrpcClient {
  ensureAuthRuntimeSubscription();
  if (!singleton) {
    singleton = createBrowserPlatformApiTrpcAdapter({
      batch: true,
      getVmPreference: () => getVmPreference(),
    });
  }

  return singleton;
}

export function getBrowserPlatformApiUnbatchedClient(): PlatformApiTrpcClient {
  ensureAuthRuntimeSubscription();
  if (!unbatchedSingleton) {
    unbatchedSingleton = createBrowserPlatformApiTrpcAdapter({
      batch: false,
      getVmPreference: () => getVmPreference(),
    });
  }

  return unbatchedSingleton;
}

export function getBrowserPlatformApiPreloadClient(): PlatformApiTrpcClient {
  ensureAuthRuntimeSubscription();
  if (!preloadSingleton) {
    preloadSingleton = createBrowserPlatformApiTrpcAdapter({
      batch: true,
      getVmPreference: () => getVmPreference(),
    });
  }

  return preloadSingleton;
}

export function getBrowserPlatformApiSubscriptionClient(): PlatformApiTrpcClient {
  ensureAuthRuntimeSubscription();
  if (!subscriptionSingleton) {
    subscriptionSingleton = createBrowserPlatformApiTrpcAdapter({
      enableSubscriptions: true,
      getVmPreference: () => getVmPreference(),
    });
  }

  return subscriptionSingleton;
}

export function resetBrowserPlatformApiClient() {
  singleton = null;
  unbatchedSingleton = null;
  preloadSingleton = null;
  subscriptionSingleton = null;
}
